import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import classNames from "classnames";
import { database } from "../app-database";
import firebase from 'firebase';
import { servicios } from './../properties';
const mapState = (state) => {
	return {
		preguntas1: state.catalogos.catalogoPregunta1,
		preguntas2: state.catalogos.catalogoPregunta2,
		dispositivo: state.global.dispositivo,
		estatus: state.recuperar.estatus
	};
};

const styleSubtitle = {
	fontSize: "12px!important",
	color: "#1f3f79"
};

const btn_toolTip = {
	background: "#ff7000",
	borderRadius: "7px",
	border: "none",
	margin: "0 0 3px 5px",
	padding: "0",
	width: "15px",
	height: "15px",
	fontSize: "12px",
	lineHeight: "12px",
	color: "#fff"
};

const mapDispatch = (dispatch) => {
	return {
		llenarPreguntas: (cat1, cat2) => {
			dispatch({ "type": "CARGAR_CATALOGO_PREGUNTAS", catalogoPregunta1: cat1, catalogoPregunta2: cat2 });
		}
	};
};

const validate = values => {
	function checkMayus(str) {
		return str.toLowerCase() != str;
	}

	const errors = {};

	if (!values.telefono_movil) {
		errors.telefono_movil = "Campo requerido.";
	} else if (!values.lada_movil && values.telefono_movil) {
		errors.telefono_movil = "Campo lada requerido.";
	} else if (values.lada_movil && values.telefono_movil && ((values.lada_movil.length + values.telefono_movil.length) - 1) != 10) {
		errors.telefono_movil = "Tu número de teléfono con lada incluida debe ser de 10 dígitos.";
	}

	if (values.lada_fijo && !values.telefono_fijo) {
		errors.telefono_fijo = "Campo requerido.";
	}
	if (!values.lada_fijo && values.telefono_fijo) {
		errors.telefono_fijo = "Campo lada fijo requerido.";
	} else if (values.lada_fijo && values.telefono_fijo && ((values.lada_fijo.length + values.telefono_fijo.length) - 1) != 10) {
		errors.telefono_fijo = "Tu número de teléfono con lada incluida debe ser de 10 dígitos.";
	}

	if (values.lada_fijo == "+" && values.telefono_fijo == "") {
		delete errors.telefono_fijo;
	} else if (values.lada_fijo == "+" && !values.telefono_fijo) {
		delete errors.telefono_fijo;
	}

	var concatTelFijo = values.lada_fijo + values.telefono_fijo;
	var concatTelCelular = values.lada_movil + values.telefono_movil;

	if (concatTelCelular === concatTelFijo) {
		errors.telefono_fijo = "Tu número de teléfono debe ser diferente.";
	}

	if (!values.password) {
		errors.password = "Campo requerido.";
	} else {
		var a = 0;
		var regexpr2 = /([\w])\1{2,}/;
		var NUMEROS = "0123456789";
		var ABC = "abcdefghijklmnopqrstuvwxyz";
		var regexpr = /\s+/;

		if (values.password.length > 0 && values.password.length <= 7) {
			errors.password = <span>Debe ser al menos de 8 posiciones.</span>;
		} else if (regexpr.test(values.password)) {
			errors.password = <span>No se admiten espacios en blanco.</span>;
		} else if (values.password.toLowerCase().includes("gnp")) {
			errors.password = <span>No debe contener la palabra GNP.</span>;
		} else if (!/^[a-z0-9]+$/i.test(values.password)) {
			errors.password = "No debe contener caracteres especiales.";
		} else if (isNaN(values.password) == false) {
			errors.password = "Debe incluir caracteres alfabéticos.";
		} else if (/[0-9]/.test(values.password) == false) {
			errors.password = "Debe contener al menos un carácter numérico.";
		} else if (regexpr2.test(values.password)) {
			errors.password = <span>No debe contener más de dos caracteres de forma consecutiva (222, abc).</span>;
		} else if (checkMayus(values.password) == false) {
			errors.password = "Debe incluir al menos una mayúscula"
		} else {
			for (var i = 0; i < values.password.length; i++) {
				var cadena = values.password.substr(i, 3).toLowerCase();
				if (cadena.length == 3 && (ABC.indexOf(cadena) >= 0 || NUMEROS.indexOf(cadena) >= 0)) {
					errors.password = <span>No debe contener más de dos caracteres de forma consecutiva (123, abc).</span>;
					break;
				}
			}
		}
	}

	if (!values.confpassword) {
		errors.confpassword = "Campo requerido.";
	} else if (values.confpassword != values.password) {
		errors.confpassword = <span>Tus contraseñas no coinciden. Favor de verificar.</span>;
	} else {
		errors.confpassword = "";
	}

	if (!values.pregunta1 || values.pregunta1 == 0) {
		errors.pregunta1 = "Campo requerido.";
	}

	if (!values.respuesta1) {
		errors.respuesta1 = "Campo requerido.";
	} else if (values.respuesta1 == values.respuesta2) {
		errors.respuesta1 = <span>Tus respuestas no deben ser iguales. Favor de verificar.</span>;
	}

	if (!values.pregunta2 || values.pregunta2 == 0) {
		errors.pregunta2 = "Campo requerido.";
	}

	if (!values.respuesta2) {
		errors.respuesta2 = "Campo requerido.";
	} else if (values.respuesta1 == values.respuesta2) {
		errors.respuesta2 = <span>Tus respuestas no deben ser iguales. Favor de verificar.</span>;
	}

	return errors;
};

const onSubmitFail = (errors, dispatch, submitError, props) => {
	if (errors.telefono_movil != "Campo requerido." || errors.password != "Campo requerido." || errors.confpassword != "Campo requerido." || errors.respuesta1 != "Campo requerido." || errors.respuesta2 != "Campo requerido.") {
		if (props.estatus == "m") {
			dispatch({ "type": "EVENT_UMIGRADO_SEGURIDAD_INCORRECTOS", "flujo": "UsuarioMigrado", "dispositivo": props.dispositivo });
		}
	}
	else {
		if (props.estatus == "m") {
			dispatch({ "type": "EVENT_UMIGRADO_SEGURIDAD_VACIOS", "flujo": "UsuarioMigrado", "dispositivo": props.dispositivo });
		}
	}
};

const espacios = tipo => (value, campos) => {
	let texto = (value != undefined && value != " ") ? value : "";
	texto = texto.replace(/\s{2,}/g, " ");
	campos[tipo] = texto;
};

const hideErrors = {};

const telefono = tipo => (value, campos) => {
	let numero = (value != undefined) ? value.replace("+", "").replace(" ", "") : "";
	let prefijo = (/lada/g.test(tipo)) ? "+" : "";

	if (numero != "" && isNaN(numero)) {
		let _temp = "";
		for (let i = 0; i < numero.length; i++) {
			if (!isNaN(numero.substr(i, 1))) {
				_temp += numero.substr(i, 1);
			}
		}
		numero = _temp;
	}

	if (numero != "") {
		campos[tipo] = prefijo + numero;
	} else {
		campos[tipo] = "";
	}
};

const renderField = ({ input, label, type, max, placeholder, meta: { touched, error, warning } }) => {
	return (
		<div>
			<input {...input} type={type} maxLength={max} placeholder={placeholder} />
			{touched && (error &&
				<div className="error-wrap">
					<div className="msj-error">
						<p><span>{error}</span></p>
					</div>
				</div>)
			}
		</div>
	);
};

const campo = ({ input, label, type, param, max, fnToggle, clase, meta: { touched, error } }) => {
	return <div className={param ? "input-wrap visible-input" : "input-wrap ver-input"}>
		<label htmlFor={input.name}>{label}</label>
		<span className="input-active">
			{!param &&
				<div>
					<input {...input} type={type} maxLength={max} className={clase} />
				</div>
			}
			{param &&
				<div >
					<input {...input} type="text" maxLength={max} className={clase} />
				</div>
			}
		</span>
		<button type="button" className="btn-ojo" onClick={fnToggle}></button>
		{touched && error &&
			<div className="error-wrap">
				<div className="msj-error">
					<p><span>{error}</span></p>
				</div>
			</div>
		}
	</div>;
};

const campoSelect = ({ input, label, type, meta: { touched, error }, children }) => {
	return (
		<div className="input-wrap no-margin">
			<label>{label}</label>
			<span className="clearfix select-active">
				<select {...input} className="col-xs-1">
					{children}
				</select>
			</span>
			{touched && error &&
				<div className="error-wrap">
					<div className="msj-error">
						<p><span>{error}</span></p>
					</div>
				</div>
			}
		</div>
	);
};

const renderSelectField = ({ input, label, type, meta: { touched, error }, children }) => (
	<div className="input-wrap no-margin">
		<label>{label}</label>
		<span className="clearfix input-active">
			<select {...input} className="col-xs-1">
				{children}
			</select>
		</span>
		{touched && error &&
			<div className="error-wrap">
				<div className="msj-error">
					<p><span>{error}</span></p>
				</div>
			</div>
		}
	</div>
);

class SeguridadForm extends React.Component {

	handleChange = (sParam, e) => {
		this.setState({ [sParam]: e.target.value });
		this.validate(sParam, e.target.value);
	}

	toggle = (sParam) => {
		this.setState({ [sParam]: !this.state[sParam] });
	}

	handleSelect = (sParam, e) => {
		this.setState({ [sParam]: e });
	}

	state = {
		showPass: false,
		showConfPass: false,
		showResp1: false,
		showResp2: false,
		password: "",
		confPassword: "",
		respuesta1: "",
		respuesta2: "",
		pregunta1: 0,
		pregunta2: 0,
		validate: {
			password: false,
			confPassword: false,
			respuesta1: false,
			respuesta2: false
		}
	}

	componentWillMount = () => {
		database.ref("preguntas").on("value", snapshot => {
			let data = snapshot.val();
			this.props.llenarPreguntas(data.pregunta1, data.pregunta2);
		});
	}

	componentDidMount = () => {
		$(".pass, .confpass").bind("copy paste", function (e) { e.preventDefault(); return false; });
		$(".gnp-generales").css("min-height", "440px");
		$(".gnp-generales").css("height", "100%");
	}

	focus = (e) => {
		hideErrors[e.target.name] = false;
	}

	cerrar = (e) => {
		hideErrors[e] = true;
		let value = document.querySelector("input[name=" + e + "]").value == "" ? " " : "";
		this.props.change(e, value);
	}
	ir = () => {
		firebase.database().ref("portales/portalReingenieria").once("value").then(oValue => {
			var data = oValue.val();
			if (!data) {
				goTo("login");
			} else {
				window.location.assign(servicios.dominioReingenieria);
			}
		})
	}

	render() {
		const { handleSubmit } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				<div>
					<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
						show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
					</ModalSintillo>

					<div className="datos-wrap mt-10" id="datos-wrap" style={{ marginTop: "35px" }}>
						<label className="txt-2" id="textSeguridad" style={{ marginTop: "28px", marginLeft: "5px" }}>CONTRASEÑA</label>
						<hr className="label-hrSeguridad" id="textSeguridadHr" style={{ marginLeft: "0px" }} />
						<div className="row">
							<div className={estiloCol} id="campo-password-seguridad" style={{ marginLeft: "5px" }}>
								<Field
									name="password" label="Contraseña" component={campo} max="24" type={this.state.showPass ? "password" : "text"}
									onChange={this.validaPassword} onFocus={this.handleFocusPassword} onBlur={this.handleBlurPassword}
									props={{ param: this.state.showPass, fnToggle: this.toggle.bind(this, "showPass") }}
								/>
								<button type="button" className={this.state.showPass ? ojito : ojitoCerrado} onClick={() => { this.viewPass() }}></button>
								{this.state.showValidatorPass &&
									<div className={modalValidPass}>
										<div className={modalValidPassBody}>
											<span style={{ margin: { estiloColpx }, width: '10%' }} className={this.validaCaracteresIcon('caracteresCompletos')} >
											</span>
											<div className={this.validaCaracteresColor('caracteresCompletos')}>
												<label className="label-text-modal-password">Debe ser al menos de 8 caracteres y máximo 24 caracteres.</label>
											</div>
										</div>
										<div className={modalValidPassBody}>
											<span style={{ margin: { estiloColpx }, width: '13%' }} className={this.validaCaracteresIcon('caracterConsecutivoIgual')} >
											</span>
											<div className={this.validaCaracteresColor('caracterConsecutivoIgual')}>
												<label className="label-text-modal-password">No debe contener más de dos caracteres
													consecutivos iguales (p.e. 222, eee).</label>
											</div>
										</div>
										<div className={modalValidPassBody}>
											<span style={{ margin: { estiloColpx }, width: '13%' }} className={this.validaCaracteresIcon('caracterConsecutivo')} >
											</span>
											<div className={this.validaCaracteresColor('caracterConsecutivo')}>
												<label className="label-text-modal-password">No debe contener más de dos caracteres
													consecutivos (p.e. 123, abc).</label>
											</div>
										</div>
									</div>}
							</div>

							<div className={estiloCol} id="campo-confPassword-seguridad">
								<Field
									name="confpassword" label="Confirmar contraseña" component={campo} max="24"
									type={this.state.showConfPass ? "password" : "text"} onBlur={this.confirmPassword}
									props={{ param: this.state.showConfPass, fnToggle: this.toggle.bind(this, "showConfPass"), clase: "confpass" }}
								/>
								<button type="button" className={this.state.showConfPass ? ojito : ojitoCerrado} onClick={() => { this.viewPassConf() }}></button>
							</div>
						</div>

						<div className="row">
							<div className="col-md-2">
								<button id="btn-continuar-seguridad"
									style={{ width: '120px', height: '48px', fontSize: '16px', padding: '14px 16px', marginTop: '34px', marginLeft: "10px" }}
									className="orange-rectangle" >Continuar</button>
							</div>
						</div>
					</div>

					<div className="modal modal-msj fade" id="modal-exito" tabIndex="-1" role="dialog" aria-labelledby="modal-exitoLabel"
						data-backdrop="static" data-keyboard="false">
						<div className="modal-dialog modal-dialog-olv" role="document">
							<div className="modal-content">
								<div className="modal-cabecera">
									<div className="icono">
										<span className='icon-circle-dove icono-modal-olvide' ></span>
									</div>

									<h5 className="text-center" id="modal-nuevo-exitoLabel">Cambios guardados</h5>
								</div>
								<div className="txt-black-olvide">
									<p>
										¡Listo! Tu contraseña ha sido actualizada.
										Ingresa tu correo y contraseña nuevamente para acceder
										a tu cuenta.
									</p>
								</div>
								<div className="text-center aceptar-cancelar-btn-2 mt-20 opciones-bloqueo">
									<button type="button" className="btn orange-btn" data-dismiss="modal" style={{ "marginRight": "50px" }} onClick={this.ir.bind(this, "login")}>Aceptar</button>

								</div>
							</div>
						</div>
					</div>

				</div>
			</form>
		);
	}
}

SeguridadForm = reduxForm({
	form: "datosSeguridad",
	validate,
	onSubmitFail
})(SeguridadForm);

export default connect(mapState, mapDispatch)(SeguridadForm);



// WEBPACK FOOTER //
// ./src/gnp-recuperar-contrasenia/seguridad.frm.js